import React, {FC, useState} from "react"

import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {FormattedMessage} from "@irati/utils/lang"
import {Body, H3} from "@irati/ui/src/Typography"
import workosService from "@irati/workos/services/workos"
import authentication from "@irati/auth"

import GenerateWorkOSLinks from "../../GenerateWorkOSLinks"
import Header from "./Header"

interface Props {
  onBack: () => void
}

const EnableSAML: FC<Props> = ({onBack}) => {
  const [generateWorkOSLinks, setGenerateLinks] = useState<boolean>(false)
  const [load, setLoad] = useState<Promise<any> | null>(null)

  const handlePrevStep = () => {
    if(!generateWorkOSLinks) {
      onBack()
    } else {
      setGenerateLinks(false)
    }
  }

  const handleWorkOS = () => {
    const ssoLoad = workosService.generatePortalLinks(authentication.business().uuid).then((portalLinks) => {
      if (portalLinks?.ssoUrl) {
        window.location = portalLinks.ssoUrl
      }
    })
    setLoad(ssoLoad)
  }

  return (
    <Flex direction="column" width="100%">
      <Header onBack={handlePrevStep} />
      <Flex direction="column" />
      {!generateWorkOSLinks ? <>
        <H3 marginBottom={1}>
          <FormattedMessage id="admin.components.integration.sso.enableSSO.saml.title" />
        </H3>
        <Body marginBottom={4}>
          <FormattedMessage id="admin.components.integration.sso.enableSSO.saml.subTitle" />
        </Body>
        <Flex>
          <div>
            <Button onClick={() => setGenerateLinks(true)} cta marginRight={1} marginTop={2}>
              <FormattedMessage id="admin.components.integration.sso.enableSSO.saml.btn.getIT" />
            </Button>
          </div>
          <Button load={load} onClick={handleWorkOS} primary marginLeft={4}>
            <FormattedMessage id="admin.components.integration.sso.enableSSO.saml.btn.workOS" />
          </Button>
        </Flex>
      </> : <GenerateWorkOSLinks isSSO isDisabled={false} />}
    </Flex>
  )
}

export default EnableSAML
